// extracted by mini-css-extract-plugin
module.exports = {"loginBtn":"OIDC_loginBtn__15B6V","loginBtn--facebook":"OIDC_loginBtn--facebook__3uq1J","loginBtn--google":"OIDC_loginBtn--google__LETQb"};